import React, { useState } from "react";
import { OwIconButton } from "../../../shared/OwIconButton/OwIconButton";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwCheckbox from "../../../shared/OwCheckbox/OwCheckbox";
import OwTitle from "../../../shared/OwTitle/OwTitle";

type Props = {
    closeModal: () => void;
    startSync: (options: { onlyUnconnectedItems: boolean }) => void;
};

export const ConnectQboCatalogItemsModal = (props: Props) => {
    const [onlyUnconnectedItems, setOnlyUnconnectedItems] = useState(false);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setOnlyUnconnectedItems(e.target.checked);
    };

    const start = () => {
        props.startSync({ onlyUnconnectedItems });
        props.closeModal();
    };

    return (
        <div className={"ConnectQboCatalogItemsModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <div>
                        <OwTitle leftIconName={"fad fa-cloud-download-alt"} title={"quickbooks_online"} tag={"h3"} />
                        <OwTitle title={"connect_catalog_items"} tag={"h5"} />
                    </div>
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={props.closeModal} />
                    </div>
                </div>
            </div>
            <div className="mt-2">
                <div className={"mt-2"}>
                    <OwCheckbox fn={handleChange} label={"only_unconnected_items"} checked={onlyUnconnectedItems} />
                </div>
            </div>

            <div className={"d-flex mt-5"}>
                <OwButton title={"start"} fn={start} />
            </div>
        </div>
    );
};
